import { useMemo } from "react";
import { Elements, PaymentMethodMessagingElement } from "@stripe/react-stripe-js";
import { StripePaymentMethodMessagingElementOptions } from "@stripe/stripe-js";

import { stripeElementsOptions, stripePromise } from "client/common/contexts/stripe";

type ProductLineKlaranAdvertisementProps = { discountedSubtotal: number };

const ProductLineKlarnaAdvertisement = ({
  discountedSubtotal,
}: ProductLineKlaranAdvertisementProps) => {
  const options = useMemo<StripePaymentMethodMessagingElementOptions>(
    () => ({
      amount: discountedSubtotal,
      currency: "USD",
      paymentMethodTypes: ["klarna"],
      countryCode: "US",
    }),
    [discountedSubtotal],
  );

  // Stripe's messaging element tears itself down when handed a non-positive
  // amount (e.g. the transient $0 subtotal while pricing loads). A later amount
  // update then calls `.update()` on the already-destroyed element and throws
  // "This Element has already been destroyed."
  if (discountedSubtotal <= 0) {
    return null;
  }

  return (
    // Isolate the ad in its own Elements group so its lifecycle is bounded to
    // this component.
    <Elements stripe={stripePromise} options={stripeElementsOptions}>
      {/*
        key={discountedSubtotal} forces a brand-new element on every amount
        change instead of calling .update() on the existing one. Stripe
        self-destroys the Klarna messaging element when an amount has no eligible
        plan (outside Klarna's promotable range or the buyer's Purchase Power),
        but react-stripe-js keeps its stale ref and calls .update() on the dead
        element on the next amount change, throwing "This Element has already
        been destroyed." Remounting sidesteps that update path. Do not remove.
      */}
      <PaymentMethodMessagingElement key={discountedSubtotal} options={options} />
    </Elements>
  );
};

export default ProductLineKlarnaAdvertisement;
